module.exports = __webpack_public_path__ + "static/media/logo.6a6e14c6.png";